// networkStatus.js
import React, { useEffect, useState } from "react";

const NetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showBanner, setShowBanner] = useState(!navigator.onLine);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowBanner(false); // hide immediately
        };

        const handleOffline = () => {
            setIsOnline(false);
            setShowBanner(true); // show immediately
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    if (!showBanner) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                backgroundColor: "#d82323ff",
                color: "#fff",
                textAlign: "center",
                padding: "10px",
                zIndex: 9999,
                transition: "opacity 0.5s ease",
                opacity: showBanner ? 1 : 0,
            }}
        >
            ⚠️ You are offline. Please check your internet connection.
        </div>
    );
};

export default NetworkStatus;
